import { BasePage } from "@Tenants/Hw/Site/BasePage";
import { BuildGroupPage } from "@Base/Selector/BuildGroupPage";
import { ReviewGroupPage } from "@Base/Selector/ReviewGroupPage";
import { SelectGroupPage } from "@Base/Selector/SelectGroupPage";
import { SelectThemePage } from "@Base/Selector/SelectThemePage";

import "./Selector.scss";

export class SelectorPage extends BasePage
{
	private readonly _buildGroupPageSelector = ".js-build-group-page";
	private readonly _reviewGroupPageSelector = ".js-review-group-page";
	private readonly _selectGroupPageSelector = ".js-select-group-page";
	private readonly _selectThemePageSelector = ".js-select-theme-page";

	public BuildGroupPage: BuildGroupPage;
	public ReviewGroupPage: ReviewGroupPage;
	public SelectGroupPage: SelectGroupPage;
	public SelectThemePage: SelectThemePage;

	constructor()
	{
		super();
		this.Initialize();
	}

	public async Initialize(): Promise<void>
	{
		super.Initialize();

		const buildGroupPage = document.querySelector(this._buildGroupPageSelector) as HTMLElement;
		const reviewGroupPage = document.querySelector(this._reviewGroupPageSelector) as HTMLElement;
		const selectGroupPage = document.querySelector(this._selectGroupPageSelector) as HTMLElement;
		const selectThemePage = document.querySelector(this._selectThemePageSelector) as HTMLElement;

		if (buildGroupPage != null)
		{
			this.BuildGroupPage = new BuildGroupPage();
		}

		if (reviewGroupPage != null)
		{
			this.ReviewGroupPage = new ReviewGroupPage();
		}

		if (selectGroupPage != null)
		{
			this.SelectGroupPage = new SelectGroupPage();
		}

		if (selectThemePage != null)
		{
			this.SelectThemePage = new SelectThemePage();
		}
	}
}

const selector = new SelectorPage();